import {IssuesLoadingSkeleton} from '@github-ui/issues-loading-skeleton'

import styles from './MetadataFooterLoading.module.css'

export const MetadataFooterLoading = () => {
  return (
    <div className={styles.MetadataFooterLoadingContainer}>
      <IssuesLoadingSkeleton borderRadius="pill" height="lg" width="400px" />
    </div>
  )
}

try{ MetadataFooterLoading.displayName ||= 'MetadataFooterLoading' } catch {}